<template>
  <div>
    <v-card class="d-flex flex-row justify-start" flat>
      <v-col class="px-0" sm="5">
        <v-card flat>
          <h3 class="text-subtitle-1">{{ label }}</h3>
          <p v-if="tooltip" class="text-caption">{{ tooltip }}</p>
        </v-card>
        <v-card class="d-flex flex-row" flat>
          <v-card v-if="autoAllocation" flat class="mx-2">
            <v-switch v-model="autoAllocationStatus" dense class="mt-0">
              <template #label>
                <p class="my-auto text-caption">Auto Allocation</p>
              </template>
            </v-switch>
          </v-card>
          <v-card flat class="mx-2">
            <slot
              v-if="!autoAllocation || (autoAllocation && !autoAllocationStatus)"
              name="constant-switch"
            ></slot>
          </v-card>
        </v-card>
      </v-col>
      <v-card flat class="grow">
        <slot v-if="!autoAllocation || !(autoAllocation && autoAllocationStatus)"></slot>
      </v-card>
    </v-card>
  </div>
</template>

<script>
export default {
  name: "InputDualParameter",
  components: {},
  mixins: [],
  props: {
    label: { type: String, required: true },
    autoAllocation: { type: Boolean, required: false, default: false },
    autoAllocated: { type: Boolean, required: false, default: false },
    tooltip: { type: String, required: false, default: "" },
  },
  data() {
    return {};
  },
  computed: {
    autoAllocationStatus: {
      get() {
        return this.autoAllocated;
      },
      set(val) {
        this.$emit("update:autoAllocated", val);
      },
    },
  },
  watch: {},
  beforeCreate() {},
  created() {},
  beforeMount() {},
  mounted() {},
  beforeUpdate() {},
  updated() {},
  activated() {},
  deactivated() {},
  beforeDestroy() {},
  destroyed() {},
  methods: {},
};
</script>

<style></style>
